import Modal from './ui/Modal.jsx';
import Button from './ui/Button.jsx';

// Confirmation modal used before deleting an invitado (FR-7.1).
// Spanish copy: "¿Eliminar a {nombre}? Esta acción no se puede deshacer."
// with Cancelar / Eliminar actions.
export default function ConfirmDelete({ open, invitado, onCancel, onConfirm, loading }) {
  const nombre = invitado?.nombre ?? '';

  return (
    <Modal open={open} onClose={onCancel} title="Eliminar invitado" ariaLabel="Eliminar invitado">
      <div className="flex flex-col gap-4">
        <p className="text-text">
          ¿Eliminar a <strong>{nombre}</strong>? Esta acción no se puede deshacer.
        </p>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onCancel} disabled={loading}>
            Cancelar
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}